<template>

  <vs-row
  vs-align="center"
  vs-type="flex" vs-justify="center" vs-w="12">
  <!-- {{bool}} -->
    <select v-model="bool"
    @change="update(params)"
      class="w-100 selectExample mt-2 customSelect">
      <option :key="index"
       :value="item.id" 
       :label="item.value"
        v-for="(item,index) 
        in boolList"
       class="selectOptionclass"/>
    </select>
  </vs-row>
</template>
<script>
import vSelect from 'vue-select'
export default {
  components:{
    vSelect
  },
  data () {
    return {
      bool: null,
      addDetailsModal:false,
        boolList:[
            {
                id:1,
                value:'True'
            },
            {
                id:0,
                value:'False'
            }
        ],
    }
  },
  /*  created () {
  }, */
  mounted () {
    this.bool= this.params.data[this.params.colDef.CellRendererParams] && this.params.data[this.params.colDef.CellRendererParams]=="1"?1:0
  },

  methods: {
      async update(data1){
          const data = []
          data.field_type = true
      data.colId = this.params.colDef.field
      data.user_id = this.params.data.basic_details.operation_user_id
      data.fieldvalue = this.bool
          this.params.colDef.filterParams.update_user(data)
      },
  }
}
</script>
<style scoped>
  .customSelect {
    border-radius:3px;
    border: 1px solid #CCCCCC;
    width: 100%;
    height:30px;
    background-color: white;
    color:#757575
    /* font-family: $font-family-base'; */
  }
  .selectOptionclass :hover
  {
    background-color:yellow;
    color:white;
    border:none;
  }

</style>
